import { createSelector } from 'reselect';
const rootSelector = (state) => state.auth;
export const authedUserSelector = createSelector(rootSelector, ({ profile }) => profile);
export const userCompaniesSelector = createSelector(rootSelector, ({ companiesList }) => companiesList);
